import { StrictMode, useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.jsx';
import Login from './auth/Login.jsx';

function Root() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const tokenData = JSON.parse(atob(token.split('.')[1]));
        const isExpired = tokenData?.exp ? tokenData.exp * 1000 < Date.now() : true;
        setIsAuthenticated(!isExpired);
      } catch (error) {
        setIsAuthenticated(false);
        localStorage.removeItem('authToken');
      }
    };

    validateToken();
  }, []);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/*"
          element={isAuthenticated ? <App /> : <Login />}
        />
      </Routes>
    </BrowserRouter>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Root />
  </StrictMode>
);
